<template>
  <content-view v-if="homePage" :homePage="homePage" />
</template>

<script setup>
import ContentView from "./ContentView.vue";

defineProps({ homePage: Object });
</script>
